/* eslint-disable max-lines-per-function */
/* eslint-disable prefer-template */
'use strict';

window.MOMENT_DATE_ENGLISH_FORMAT = 'Y-MM-DD';

angular.module('webAgro1App').factory('RelatorioVisitaService', function($http, $rootScope, $q) {
  return {
    generateUrl: function(relatorio, base) {
      return SERVER + (base || 'v1/operacoes_campo/relatorio_visita') +
        '?propriedade=' + $rootScope.currentPropriedade.id +
        '&token=' + $rootScope.currentUser.token +
        '&relatorio=' + relatorio;
    },

    generateHtmlLink: function(uuid) {
      return `${SERVER}/relatorio_visita/${uuid}`;
    },

    list: function(filters) {
      const _this = this;
      return $http.get(SERVER + 'v2/relatorio_visita', {
        params: filters
      }).then(function(result) {
        const newData = result.data.map(function(item) {
          return {
            ...item,
            htmlLink: _this.generateHtmlLink(item.uuid)
          };
        });
        result.data = newData;

        return result;
      });
    },

    remove: function(id) {
      return $http.delete(SERVER + 'v2/relatorio_visita/' + id);
    },

    get: function(id) {
      return $http.get(SERVER + 'v2/relatorio_visita/' + id);
    },

    gerar: function(payload) {
      const deferred = $q.defer();

      $http.post(SERVER + 'v2/relatorio_visita', { relatorio: payload }).then(function(relatorio) {
        const result = relatorio.data;
        result.url = SERVER + result.url;
        deferred.resolve(result);
      }, deferred.reject);

      return deferred.promise;
    },

    gerarVarios: function(payload) {
      const deferred = $q.defer();

      $http.post(`${SERVER }v2/relatorio_visita/bulk_generate`, { ids: payload }).then(function(relatorio) {
        const result = relatorio.data;
        result.url = SERVER + result.url;
        deferred.resolve(result);
      }, deferred.reject);

      return deferred.promise;
    },

    download: function(params) {
      return $http.get(`${SERVER}v2/relatorio_visita/${params.job_id}/download`)
        .then((result) => result);
    }
  };
});
